import HPTMedicareRelativityTool from './view';
import {createHPTQuery} from './filter-steps/professional-steps/query';
import HPTProfessionalFilterStepsConfig from './filter-steps/professional-steps/config';
import {useMemo} from 'react';
import HPTProfessionalFilterStepsStore from './filter-steps/professional-steps/professional-store';
export default function HPTProfessionalTool() {
    const hptFilterStore = useMemo(() => HPTProfessionalFilterStepsStore.empty(), []);
    return <HPTMedicareRelativityTool createHPTQuery={createHPTQuery} filterSteps={HPTProfessionalFilterStepsConfig} hptFilterStore={hptFilterStore} title="Milliman Professional Insights"/>;
}